export default "__VITE_ASSET__DcvL0TrY__"